"use client";

import { c as _c } from "react/compiler-runtime";
import { PrescriptionForm } from "../../app/[tenant]/(console)/scribe/playground/[id]/weight-loss/prescription-form";
import { useRef, useState } from "react";
import { FaPrint } from "react-icons/fa";
import Button from "@/components/ui/button";
import { Dialog, DialogBody, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { openPrintWindow } from "@/lib/print-utils";
import { MedicationSummary } from "@/types/medication";
import { PatientSummary } from "@/types/patient";
interface PrintPrescriptionProps {
  medication: MedicationSummary;
  patient: PatientSummary;
  children: React.ReactNode;
}
export default function PrintPrescription(t0) {
  const $ = _c(24);
  const {
    medication,
    patient,
    children
  } = t0;
  const [open, setOpen] = useState(false);
  const printRef = useRef(null);
  let t1;
  if ($[0] !== patient.firstName || $[1] !== patient.lastName) {
    t1 = () => {
      if (!printRef.current) {
        return;
      }
      const printContent = printRef.current.innerHTML;
      openPrintWindow(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Prescription - ${patient.firstName} ${patient.lastName}</title>
          <style>
            body {
              margin: 0;
              padding: 20px;
              font-family: Arial, sans-serif;
              font-size: 12px;
              line-height: 1.4;
              color: black;
              background: white;
            }
            .mx-auto { margin-left: auto; margin-right: auto; }
            .max-w-2xl { max-width: 42rem; }
            . { background-color: white; }
            .p-8 { padding: 2rem; }
            .text-black { color: black; }
            .text-center { text-align: center; }
            .text-left { text-align: left; }
            .text-right { text-align: right; }
            .mb-1 { margin-bottom: 0.25rem; }
            .mb-2 { margin-bottom: 0.5rem; }
            .mb-4 { margin-bottom: 1rem; }
            .mb-6 { margin-bottom: 1.5rem; }
            .mb-8 { margin-bottom: 2rem; }
            .mt-1 { margin-top: 0.25rem; }
            .mt-2 { margin-top: 0.5rem; }
            .mt-12 { margin-top: 3rem; }
            .pt-8 { padding-top: 2rem; }
            .py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; }
            .text-lg { font-size: 1.125rem; }
            .text-body { font-size: 0.875rem; }
            .font-bold { font-weight: bold; }
            .font-medium { font-weight: 500; }
            .flex { display: flex; }
            .justify-between { justify-content: space-between; }
            .border-t { border-top: 1px solid #9ca3af; }
            .border-b { border-bottom: 1px solid #9ca3af; }
            .border-gray-400 { border-color: #9ca3af; }
            .w-64 { width: 16rem; }
            .uppercase { text-transform: uppercase; }
            @media print {
              body { margin: 0; padding: 0; }
              .no-print { display: none; }
            }
          </style>
        </head>
        <body>
          ${printContent}
        </body>
      </html>
    `);
    };
    $[0] = patient.firstName;
    $[1] = patient.lastName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handlePrint = t1;
  let t2;
  if ($[3] !== children) {
    t2 = <DialogTrigger asChild={true}>{children}</DialogTrigger>;
    $[3] = children;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DialogTitle>Print Prescription</DialogTitle>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== patient.firstName || $[7] !== patient.lastName) {
    t4 = <DialogHeader>{t3}<DialogDescription>Review the prescription before printing. This will generate a prescription form for {patient.firstName} {patient.lastName}.</DialogDescription></DialogHeader>;
    $[6] = patient.firstName;
    $[7] = patient.lastName;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== medication || $[10] !== patient) {
    t5 = <DialogBody><div className="overflow-hidden rounded-lg border"><PrescriptionForm ref={printRef} medication={medication} patient={patient} /></div></DialogBody>;
    $[9] = medication;
    $[10] = patient;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Button variant="secondary" onClick={() => setOpen(false)}>Cancel</Button>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FaPrint className="h-4 w-4" />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== handlePrint) {
    t8 = <DialogFooter>{t6}<Button variant="primary" onClick={handlePrint} className="flex items-center gap-2">{t7}Print Prescription</Button></DialogFooter>;
    $[14] = handlePrint;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t4 || $[17] !== t5 || $[18] !== t8) {
    t9 = <DialogContent className="max-h-[90vh] max-w-4xl overflow-y-auto">{t4}{t5}{t8}</DialogContent>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== open || $[21] !== t2 || $[22] !== t9) {
    t10 = <Dialog open={open} onOpenChange={setOpen}>{t2}{t9}</Dialog>;
    $[20] = open;
    $[21] = t2;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}